

























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { APINotification } from '@/models/api/notification.model'
import moment from 'moment'

interface Pagination {
    currentPage: number;
    total: number;
    nextPage: boolean|null;
    previousPage: boolean|null;
    limit: number;
}

@Component({
    components: {
        ConfirmDialog
    }
})
export default class Notification extends Vue {
    @Prop({ required: true }) getDateFormat!: () => {};
    @Prop({ required: true }) refreshTrigger!: boolean
    @Prop({ required: false }) providerId!: number
    @Prop({ required: true }) carrierId!: number
    @Prop({ required: true }) formData!: { msisdn: string; provider: null|number }

    @Watch('refreshTrigger')
    refreshHandler () {
        this.getNotifications()
    }

    localLoading = false
    lastPage: number|null = null
    confirmDialogTrigger = false
    confirmDialogData = null
    now = moment().format('DD/MM/YYYY').toString()

    tables = {
        notification: {
            data: [],
            columns: [
                {
                    text: 'Notification Type',
                    value: 'notificationType'
                },
                {
                    text: 'Notification Created At',
                    value: 'notificationCreatedAt'
                },
                {
                    text: 'Notification Processed At',
                    value: 'notificationProcessedAt'
                },
                {
                    text: 'Retries',
                    value: 'notificationRetries'
                },
                {
                    text: 'Status',
                    value: 'notificationStatus'
                },
                {
                    text: 'Actions',
                    value: 'options'
                }
            ]
        }
    }

    notifications: { pagination: Pagination } = {
        pagination: {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null,
            limit: 15
        }
    }

    validDate (date: string) {
        return date.substring(0, 10) === this.now
    }

    mounted () {
        this.localLoading = true
        this.getNotifications()
    }

    onPaginationChange (params: { page: number}) {
        if (params.page !== this.lastPage) this.getNotifications()
    }

    newLimitHandler (limit: number) {
        this.notifications.pagination.limit = limit
        this.getNotifications()
    }

    getNotifications () {
        return new Promise(resolve => {
            this.lastPage = this.notifications.pagination.currentPage
            this.localLoading = true

            const filters = [
                {
                    value: 'providerId',
                    queryValue: this.providerId
                },
                {
                    value: 'notificationMsisdn',
                    queryValue: this.formData.msisdn
                }
            ]
            this.$store.dispatch('getMonitorNotification', { page: this.notifications.pagination.currentPage, filters: filters, limit: this.notifications.pagination.limit })
                .then(resp => {
                    this.localLoading = false
                    if (resp?.status === 200) {
                        this.notifications.pagination.total = parseInt(resp.data.total)
                        const notifications = resp.data.results
                        this.tables.notification.data = notifications
                        this.$emit('localLoadingEnd')
                        resolve()
                    }
                })
        })
    }

    confirmedDialog (item: APINotification) {
        return new Promise(resolve => {
            this.localLoading = true

            item.notificationRetries = item.notificationRetries + 1
            item.notificationStatus = 'pending'
            item.notificationProcessedAt = ''

            this.$store.dispatch('reprocessNotification', item)
                .then(resp => {
                    if (resp.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.getNotifications()
                        resolve()
                    }
                })
        })
    }
}
